import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'sonner';
import { useLocale } from '../../hooks/useLocale';
import { useAuthStore } from '../../stores/useAuthStore';

const AuthenticatedRoute = () => {
	const { t } = useLocale('generic');

	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

	useEffect(() => {
		if (!isAuthenticated) {
			toast.error(t('sessionExpiredPleaseLogIn'));
		}
	}, [isAuthenticated, t]);

	return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default AuthenticatedRoute;
